var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45936 16.5L6.03787 14.4008L11.1981 9.9275L15.4277 13.5942L23.2632 6.7925L21.7722 5.5L15.4277 11L11.1981 7.33333L4.53634 13.0992L2.11486 11V16.5H8.45936Z",
    fill: "#FA4144"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarw);
export default __webpack_public_path__ + "static/media/downarw.1ffec51bb5608e4618b8cd06b7bb006a.svg";
export { ForwardRef as ReactComponent };